/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Col_WebInputs */

const vi_shop_col_web = /** @type {(inputs: Shop_Col_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web`)
};

/**

* @param {Shop_Col_WebInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_col_web = /** @type {((inputs?: Shop_Col_WebInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Col_WebInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_col_web(inputs)
});